<template>
  <div
    class="auth-field"
    :class="{ 'auth-field--focused': focused, 'auth-field--error': hasError }"
  >
    <label v-if="label" class="auth-field__label">{{ label }}</label>
    <div class="auth-field__wrap">
      <span v-if="$slots.icon" class="auth-field__icon">
        <slot name="icon" />
      </span>
      <input
        v-if="hasMask"
        :key="'masked-' + mask"
        v-mask="mask"
        :type="inputType"
        class="auth-field__input"
        :class="inputClasses"
        :placeholder="placeholder"
        :value="modelValue"
        :disabled="disabled"
        @input="onInput"
        @focus="focused = true"
        @blur="onBlur"
        @change="$emit('change', $event)"
      />
      <input
        v-else
        :type="inputType"
        class="auth-field__input"
        :class="inputClasses"
        :placeholder="placeholder"
        :value="modelValue"
        :disabled="disabled"
        @input="onInput"
        @focus="focused = true"
        @blur="onBlur"
        @change="$emit('change', $event)"
      />
      <button
        v-if="isPassword"
        type="button"
        class="auth-field__toggle"
        tabindex="-1"
        @click="showPwd = !showPwd"
      >
        <svg v-if="showPwd" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
          <line x1="1" y1="1" x2="23" y2="23" />
        </svg>
        <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      </button>
    </div>
    <p v-for="(msg, i) in errors" :key="i" class="auth-field__error">{{ msg }}</p>
    <p v-if="hint && !hasError" class="auth-field__hint">{{ hint }}</p>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'AuthInput',
  directives: { mask },
  props: {
    modelValue: { type: String, default: '' },
    label: { type: String, default: '' },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    errors: { type: Array, default: () => [] },
    hint: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    mask: { type: [String, Boolean], default: false },
  },
  emits: ['update:modelValue', 'blur', 'change'],
  data() {
    return {
      focused: false,
      showPwd: false,
    };
  },
  computed: {
    hasMask() {
      return typeof this.mask === 'string' && this.mask.length > 0;
    },
    inputClasses() {
      return {
        'auth-field__input--icon': !!this.$slots.icon,
        'auth-field__input--password': this.isPassword,
      };
    },
    isPassword() {
      return this.type === 'password';
    },
    inputType() {
      if (!this.isPassword) return this.type;
      return this.showPwd ? 'text' : 'password';
    },
    hasError() {
      return this.errors.length > 0;
    },
  },
  methods: {
    onInput(e) {
      this.$emit('update:modelValue', e.target.value);
    },
    onBlur(e) {
      this.focused = false;
      this.$emit('blur', e);
    },
  },
};
</script>
